import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { StyledRoleButton } from './role-button.styles';
import { RoleButtonProps } from './role-button.types';
export const RoleButton = ({
  icon,
  label,
  isButtonSelected,
  onClick,
  isPremium
}: RoleButtonProps) => {
  const isNotPremiumAndNoFoundational = !isPremium && label !== 'Foundational';
  return <StyledRoleButton isButtonSelected={isButtonSelected} onClick={onClick} $isDisabled={isNotPremiumAndNoFoundational} data-sentry-element="StyledRoleButton" data-sentry-component="RoleButton" data-sentry-source-file="role-button.tsx">
      <span>
        <FontAwesomeIcon icon={icon} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="role-button.tsx" /> {label}
      </span>
      {isButtonSelected && <FontAwesomeIcon icon={faChevronRight} data-icon="arrow" />}
      {isNotPremiumAndNoFoundational && <FontAwesomeIcon icon={faLock} data-icon="lock" />}
    </StyledRoleButton>;
};